export default {
  apiUrl: 'https://api.guestyforhosts.com',
  applicationHost: 'https://app.guestyforhosts.com',
  dioBaseUrl: 'https://app.guesty.com/api',
  googleClientId: '1046481227814-f8fuc27ac5l91lndmrgrkk9pcdu9kh1d.apps.googleusercontent.com',
};
